import React from 'react';
import { useNavigate } from 'react-router-dom';
import './backButton.scss';


const BackButton = ({ label = 'Back' }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <button
            type="button"
            onClick={handleBack}
            className="back-button"
            aria-label="Go back"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="8.75"
                viewBox="0 0 12 11"
                fill="none"
                className="back-icon"
            >
                <path
                    d="M5.375 9.75L1 5.375L5.375 1"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1 5.375H11"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>

            {label && <span className="back-label">{label}</span>}
        </button>
    );
};

export default BackButton;
